module.exports = __webpack_public_path__ + "static/media/PaddingSelected.852dec5a.svg";